const o = {
  IconAddImage: () => import("./IconAddImage.js"),
  IconAddToCart: () => import("./IconAddToCart.js"),
  IconAlert: () => import("./IconAlert.js"),
  IconAlertFilled: () => import("./IconAlertFilled.js"),
  IconArchive: () => import("./IconArchive.js"),
  IconArrowDown: () => import("./IconArrowDown.js"),
  IconArrowDownLeft: () => import("./IconArrowDownLeft.js"),
  IconArrowDownRight: () => import("./IconArrowDownRight.js"),
  IconArrowLeft: () => import("./IconArrowLeft.js"),
  IconArrowRight: () => import("./IconArrowRight.js"),
  IconArrowUp: () => import("./IconArrowUp.js"),
  IconArrowUpLeft: () => import("./IconArrowUpLeft.js"),
  IconArrowUpRight: () => import("./IconArrowUpRight.js"),
  IconAttachment: () => import("./IconAttachment.js"),
  IconAvatar: () => import("./IconAvatar.js"),
  IconAvatarFilled: () => import("./IconAvatarFilled.js"),
  IconBackMarket: () => import("./IconBackMarket.js"),
  IconBackMarketApp: () => import("./IconBackMarketApp.js"),
  IconBackMarketAvatar: () => import("./IconBackMarketAvatar.js"),
  IconBackMarketPromise: () => import("./IconBackMarketPromise.js"),
  IconBadge: () => import("./IconBadge.js"),
  IconBank: () => import("./IconBank.js"),
  IconBankIn: () => import("./IconBankIn.js"),
  IconBankOut: () => import("./IconBankOut.js"),
  IconBattery: () => import("./IconBattery.js"),
  IconBellAlert: () => import("./IconBellAlert.js"),
  IconBellDisabled: () => import("./IconBellDisabled.js"),
  IconBellFilled: () => import("./IconBellFilled.js"),
  IconBellOutlined: () => import("./IconBellOutlined.js"),
  IconBike: () => import("./IconBike.js"),
  IconBill: () => import("./IconBill.js"),
  IconBlocked: () => import("./IconBlocked.js"),
  IconBluetooth: () => import("./IconBluetooth.js"),
  IconBolt: () => import("./IconBolt.js"),
  IconBoltDisabled: () => import("./IconBoltDisabled.js"),
  IconBoltFilled: () => import("./IconBoltFilled.js"),
  IconBurger: () => import("./IconBurger.js"),
  IconCalendar: () => import("./IconCalendar.js"),
  IconCalendarWithCheck: () => import("./IconCalendarWithCheck.js"),
  IconCamera: () => import("./IconCamera.js"),
  IconCameraViewfinder: () => import("./IconCameraViewfinder.js"),
  IconCardView: () => import("./IconCardView.js"),
  IconCellSignal: () => import("./IconCellSignal.js"),
  IconChargingWire: () => import("./IconChargingWire.js"),
  IconChart: () => import("./IconChart.js"),
  IconCharter: () => import("./IconCharter.js"),
  IconCheckInCircle: () => import("./IconCheckInCircle.js"),
  IconCheckInCircleFilled: () => import("./IconCheckInCircleFilled.js"),
  IconCheckLarge: () => import("./IconCheckLarge.js"),
  IconCheckSmall: () => import("./IconCheckSmall.js"),
  IconCheckWithSparkles: () => import("./IconCheckWithSparkles.js"),
  IconChevronDown: () => import("./IconChevronDown.js"),
  IconChevronLeft: () => import("./IconChevronLeft.js"),
  IconChevronRight: () => import("./IconChevronRight.js"),
  IconChevronUp: () => import("./IconChevronUp.js"),
  IconCircle: () => import("./IconCircle.js"),
  IconClock: () => import("./IconClock.js"),
  IconComment: () => import("./IconComment.js"),
  IconCompare: () => import("./IconCompare.js"),
  IconCompass: () => import("./IconCompass.js"),
  IconComputerMouse: () => import("./IconComputerMouse.js"),
  IconContact: () => import("./IconContact.js"),
  IconController: () => import("./IconController.js"),
  IconCookie: () => import("./IconCookie.js"),
  IconCopy: () => import("./IconCopy.js"),
  IconCpu: () => import("./IconCpu.js"),
  IconCreditCard: () => import("./IconCreditCard.js"),
  IconCross: () => import("./IconCross.js"),
  IconCrosshair: () => import("./IconCrosshair.js"),
  IconCrossInCircle: () => import("./IconCrossInCircle.js"),
  IconCrossInCircleFilled: () => import("./IconCrossInCircleFilled.js"),
  IconCrossInCircleFilledSmall: () => import("./IconCrossInCircleFilledSmall.js"),
  IconCrossSmall: () => import("./IconCrossSmall.js"),
  IconCupcake: () => import("./IconCupcake.js"),
  IconCurrencyAustralianDollar: () => import("./IconCurrencyAustralianDollar.js"),
  IconCurrencyDollar: () => import("./IconCurrencyDollar.js"),
  IconCurrencyEuro: () => import("./IconCurrencyEuro.js"),
  IconCurrencyPound: () => import("./IconCurrencyPound.js"),
  IconCurrencySwedishKrone: () => import("./IconCurrencySwedishKrone.js"),
  IconCurrencyYen: () => import("./IconCurrencyYen.js"),
  IconCycle: () => import("./IconCycle.js"),
  IconDeal: () => import("./IconDeal.js"),
  IconDealFilled: () => import("./IconDealFilled.js"),
  IconDesign: () => import("./IconDesign.js"),
  IconDiamond: () => import("./IconDiamond.js"),
  IconDoubleChevronSideways: () => import("./IconDoubleChevronSideways.js"),
  IconDoubleChevronUp: () => import("./IconDoubleChevronUp.js"),
  IconDownload: () => import("./IconDownload.js"),
  IconEdit: () => import("./IconEdit.js"),
  IconEiffelTower: () => import("./IconEiffelTower.js"),
  IconEqual: () => import("./IconEqual.js"),
  IconEqualizer: () => import("./IconEqualizer.js"),
  IconEqualizerSmall: () => import("./IconEqualizerSmall.js"),
  IconExpand: () => import("./IconExpand.js"),
  IconExport: () => import("./IconExport.js"),
  IconExpressReplacement: () => import("./IconExpressReplacement.js"),
  IconExternalLink: () => import("./IconExternalLink.js"),
  IconEyeClosed: () => import("./IconEyeClosed.js"),
  IconEyeOpen: () => import("./IconEyeOpen.js"),
  IconEyes: () => import("./IconEyes.js"),
  IconFactory: () => import("./IconFactory.js"),
  IconFigma: () => import("./IconFigma.js"),
  IconFile: () => import("./IconFile.js"),
  IconFingerprint: () => import("./IconFingerprint.js"),
  IconFire: () => import("./IconFire.js"),
  IconFireFilled: () => import("./IconFireFilled.js"),
  IconFlag: () => import("./IconFlag.js"),
  IconFloat: () => import("./IconFloat.js"),
  IconGear: () => import("./IconGear.js"),
  IconGearUpdate: () => import("./IconGearUpdate.js"),
  IconGift: () => import("./IconGift.js"),
  IconGitHubFilled: () => import("./IconGitHubFilled.js"),
  IconGlasses: () => import("./IconGlasses.js"),
  IconGlobe: () => import("./IconGlobe.js"),
  IconGoldenGate: () => import("./IconGoldenGate.js"),
  IconGpu: () => import("./IconGpu.js"),
  IconGrade: () => import("./IconGrade.js"),
  IconGrowth: () => import("./IconGrowth.js"),
  IconHdmi: () => import("./IconHdmi.js"),
  IconHeadset: () => import("./IconHeadset.js"),
  IconHeart: () => import("./IconHeart.js"),
  IconHeartBroken: () => import("./IconHeartBroken.js"),
  IconHeartDiagnostic: () => import("./IconHeartDiagnostic.js"),
  IconHeartExploded: () => import("./IconHeartExploded.js"),
  IconHeartFilled: () => import("./IconHeartFilled.js"),
  IconHome: () => import("./IconHome.js"),
  IconHomeFilled: () => import("./IconHomeFilled.js"),
  IconImage: () => import("./IconImage.js"),
  IconInboxTray: () => import("./IconInboxTray.js"),
  IconInfo: () => import("./IconInfo.js"),
  IconInfoFilled: () => import("./IconInfoFilled.js"),
  IconKeyboard: () => import("./IconKeyboard.js"),
  IconLanguage: () => import("./IconLanguage.js"),
  IconLaptop: () => import("./IconLaptop.js"),
  IconLaptopCamera: () => import("./IconLaptopCamera.js"),
  IconLeaf: () => import("./IconLeaf.js"),
  IconLightbulb: () => import("./IconLightbulb.js"),
  IconListView1: () => import("./IconListView1.js"),
  IconListView2: () => import("./IconListView2.js"),
  IconListViewChecks: () => import("./IconListViewChecks.js"),
  IconLocationPinFilled: () => import("./IconLocationPinFilled.js"),
  IconLocationPinOutlined: () => import("./IconLocationPinOutlined.js"),
  IconLockLocked: () => import("./IconLockLocked.js"),
  IconLockUnlocked: () => import("./IconLockUnlocked.js"),
  IconLogOut: () => import("./IconLogOut.js"),
  IconMagsafe: () => import("./IconMagsafe.js"),
  IconMail: () => import("./IconMail.js"),
  IconMedal: () => import("./IconMedal.js"),
  IconMediaPause: () => import("./IconMediaPause.js"),
  IconMediaPlay: () => import("./IconMediaPlay.js"),
  IconMediaStop: () => import("./IconMediaStop.js"),
  IconMegaphone: () => import("./IconMegaphone.js"),
  IconMinus: () => import("./IconMinus.js"),
  IconMinusInCircle: () => import("./IconMinusInCircle.js"),
  IconMoney: () => import("./IconMoney.js"),
  IconMoreHorizontal: () => import("./IconMoreHorizontal.js"),
  IconMoreVertical: () => import("./IconMoreVertical.js"),
  IconMove: () => import("./IconMove.js"),
  IconOfficial: () => import("./IconOfficial.js"),
  IconOfficialFilled: () => import("./IconOfficialFilled.js"),
  IconPackage: () => import("./IconPackage.js"),
  IconPaintBrush: () => import("./IconPaintBrush.js"),
  IconPeople: () => import("./IconPeople.js"),
  IconPercentage: () => import("./IconPercentage.js"),
  IconPerformance: () => import("./IconPerformance.js"),
  IconPlug: () => import("./IconPlug.js"),
  IconPlus: () => import("./IconPlus.js"),
  IconPlusInCircle: () => import("./IconPlusInCircle.js"),
  IconPower: () => import("./IconPower.js"),
  IconPowerAdapterApple: () => import("./IconPowerAdapterApple.js"),
  IconPriceTag: () => import("./IconPriceTag.js"),
  IconPriceTagFilled: () => import("./IconPriceTagFilled.js"),
  IconPriceUpdate: () => import("./IconPriceUpdate.js"),
  IconPrint: () => import("./IconPrint.js"),
  IconPromo: () => import("./IconPromo.js"),
  IconQuality: () => import("./IconQuality.js"),
  IconQuestionMarkInCircle: () => import("./IconQuestionMarkInCircle.js"),
  IconRecommendation: () => import("./IconRecommendation.js"),
  IconRefresh: () => import("./IconRefresh.js"),
  IconRefund: () => import("./IconRefund.js"),
  IconRepairHome: () => import("./IconRepairHome.js"),
  IconRepairMailIn: () => import("./IconRepairMailIn.js"),
  IconRepairSelf: () => import("./IconRepairSelf.js"),
  IconRepairStore: () => import("./IconRepairStore.js"),
  IconRocket: () => import("./IconRocket.js"),
  IconScooter: () => import("./IconScooter.js"),
  IconScratches: () => import("./IconScratches.js"),
  IconSdhcCard: () => import("./IconSdhcCard.js"),
  IconSearch: () => import("./IconSearch.js"),
  IconSearchFilled: () => import("./IconSearchFilled.js"),
  IconSend: () => import("./IconSend.js"),
  IconShare: () => import("./IconShare.js"),
  IconShareAndroid: () => import("./IconShareAndroid.js"),
  IconShop: () => import("./IconShop.js"),
  IconShopFilled: () => import("./IconShopFilled.js"),
  IconShoppingBag: () => import("./IconShoppingBag.js"),
  IconSim: () => import("./IconSim.js"),
  IconSiren: () => import("./IconSiren.js"),
  IconSmartphone: () => import("./IconSmartphone.js"),
  IconSmartphoneBroken: () => import("./IconSmartphoneBroken.js"),
  IconSmartphoneCamera: () => import("./IconSmartphoneCamera.js"),
  IconSmartphoneFilled: () => import("./IconSmartphoneFilled.js"),
  IconSmartphoneScreenSize: () => import("./IconSmartphoneScreenSize.js"),
  IconSort: () => import("./IconSort.js"),
  IconSos: () => import("./IconSos.js"),
  IconSoundLow: () => import("./IconSoundLow.js"),
  IconSoundOff: () => import("./IconSoundOff.js"),
  IconSoundOn: () => import("./IconSoundOn.js"),
  IconSparkles: () => import("./IconSparkles.js"),
  IconSpinner: () => import("./IconSpinner.js"),
  IconStarFilled: () => import("./IconStarFilled.js"),
  IconStarHalf: () => import("./IconStarHalf.js"),
  IconStarOutlined: () => import("./IconStarOutlined.js"),
  IconSwap: () => import("./IconSwap.js"),
  IconSwapFilled: () => import("./IconSwapFilled.js"),
  IconTablet: () => import("./IconTablet.js"),
  IconThumbsDownFilled: () => import("./IconThumbsDownFilled.js"),
  IconThumbsDownOutlined: () => import("./IconThumbsDownOutlined.js"),
  IconThumbsUpFilled: () => import("./IconThumbsUpFilled.js"),
  IconThumbsUpOutlined: () => import("./IconThumbsUpOutlined.js"),
  IconTools: () => import("./IconTools.js"),
  IconTouch: () => import("./IconTouch.js"),
  IconTouchbar: () => import("./IconTouchbar.js"),
  IconTrade: () => import("./IconTrade.js"),
  IconTrash: () => import("./IconTrash.js"),
  IconTrophy: () => import("./IconTrophy.js"),
  IconTruck: () => import("./IconTruck.js"),
  IconTruckExpress: () => import("./IconTruckExpress.js"),
  IconTv: () => import("./IconTv.js"),
  IconUndo: () => import("./IconUndo.js"),
  IconUpload: () => import("./IconUpload.js"),
  IconWarning: () => import("./IconWarning.js"),
  IconWatch: () => import("./IconWatch.js"),
  IconWaterdrop: () => import("./IconWaterdrop.js"),
  IconWifi: () => import("./IconWifi.js"),
  IconReassuranceAdyen: () => import("./IconReassuranceAdyen.js"),
  IconReassuranceArrowFilled: () => import("./IconReassuranceArrowFilled.js"),
  IconReassuranceArrowOutlined: () => import("./IconReassuranceArrowOutlined.js"),
  IconReassuranceCalendar14Days: () => import("./IconReassuranceCalendar14Days.js"),
  IconReassuranceCalendar30Days: () => import("./IconReassuranceCalendar30Days.js"),
  IconReassuranceCertified: () => import("./IconReassuranceCertified.js"),
  IconReassuranceConfianza: () => import("./IconReassuranceConfianza.js"),
  IconReassuranceCreditCardFilled: () => import("./IconReassuranceCreditCardFilled.js"),
  IconReassuranceCreditCardOutlined: () => import("./IconReassuranceCreditCardOutlined.js"),
  IconReassuranceFevad: () => import("./IconReassuranceFevad.js"),
  IconReassuranceGlobeFilled: () => import("./IconReassuranceGlobeFilled.js"),
  IconReassuranceGlobeOutlined: () => import("./IconReassuranceGlobeOutlined.js"),
  IconReassuranceGoogle: () => import("./IconReassuranceGoogle.js"),
  IconReassuranceLockFilled: () => import("./IconReassuranceLockFilled.js"),
  IconReassuranceLockOutlined: () => import("./IconReassuranceLockOutlined.js"),
  IconReassuranceParcelFilled: () => import("./IconReassuranceParcelFilled.js"),
  IconReassuranceParcelOutlined: () => import("./IconReassuranceParcelOutlined.js"),
  IconReassuranceShield12Months: () => import("./IconReassuranceShield12Months.js"),
  IconReassuranceShield24Months: () => import("./IconReassuranceShield24Months.js"),
  IconReassuranceShield36Months: () => import("./IconReassuranceShield36Months.js"),
  IconReassuranceShield6Months: () => import("./IconReassuranceShield6Months.js"),
  IconReassuranceShieldFilled: () => import("./IconReassuranceShieldFilled.js"),
  IconReassuranceShieldOutlined: () => import("./IconReassuranceShieldOutlined.js"),
  IconReassuranceSmileyFilled: () => import("./IconReassuranceSmileyFilled.js"),
  IconReassuranceSmileyOutlined: () => import("./IconReassuranceSmileyOutlined.js"),
  IconReassuranceTruckFilled: () => import("./IconReassuranceTruckFilled.js"),
  IconReassuranceTruckOutlined: () => import("./IconReassuranceTruckOutlined.js"),
  IconReassuranceTrustedShops: () => import("./IconReassuranceTrustedShops.js"),
  IconSunBeam: () => import("./IconSunBeam.js"),
  IconSunFace: () => import("./IconSunFace.js"),
  IconAi: () => import("./IconAi.js")
};
export {
  o as iconModules
};
